import { DefaultError } from '@tanstack/react-query';
import { Stack, Typography, IconButton, Button } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import React from 'react';

type ErrorButtonProps = {
    error: DefaultError | null | undefined;
    onRetry: () => void;
};

export default function ErrorButton({ error, onRetry }: ErrorButtonProps) {
  if (!error) return null;

  //@ts-ignore
  const message = error?.response?.data?.message;

  return (
    <Stack style={{ position: "relative" }}>
      <Button
        sx={{ height: 35 }}
        variant="contained"
        startIcon={<ErrorOutlineIcon />}
        onClick={onRetry}
        color={"error"}
      >
        Retry
      </Button>
      <Stack style={{ position: "absolute", top: -35 }}>
        <Typography
          style={{
            fontSize: 12,
            color: "red",
            fontWeight: "bold",
          }}
        >
          Error: {error.message}
        </Typography>
        {message && (
          <Typography
            style={{
              fontSize: 12,
              color: "red",
              fontWeight: "bold",
            }}
          >
            Message: {message}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
}
